<rc-app-bar [backdrop]="true">
  @let searchLabel = "SEARCH" | translate | capitalize;
  <button
    appBarSearch
    type="button"
    class="main-layout__search-toggle"
    [class.main-layout__search-toggle--open]="isSearchOpen()"
    [title]="searchLabel + ' (' + searchShortcut + ')'"
    [attr.aria-label]="searchLabel"
    [attr.aria-expanded]="isSearchOpen()"
    (click)="toggleSearch()">
    <i class="rc-icon-search"></i>
  </button>
  @let helpLabel = "HELP" | translate | capitalize;
  <button
    appBarSearch
    type="button"
    class="main-layout__search-toggle main-layout__help-toggle"
    [class.main-layout__search-toggle--open]="isHelpOpen()"
    [title]="helpLabel + ' (?)'"
    [attr.aria-label]="helpLabel"
    [attr.aria-expanded]="isHelpOpen()"
    (click)="toggleHelp()">
    <i class="rc-icon-help"></i>
  </button>
</rc-app-bar>

@if (isSearchOpen()) {
  <!-- Opened with the search icon, Ctrl/Cmd + K or Shift + F, over the page; closed with escape or a click next to it -->
  <kendo-dialog
    class="main-layout__search-dialog"
    autoFocusedElement=".main-layout__search-box input"
    [animation]="{ type: 'fade', duration: 150 }"
    (close)="closeSearch()"
    (click)="onSearchDialogClick($event)">
    <rc-search-box
      #searchBox
      class="main-layout__search"
      boxClass="main-layout__search-box w-100"
      [inlineResults]="true"
      [hitTypes]="searchHitTypes"
      [types]="searchTypes()"
      [allTypes]="allSearchTypes()"
      [itemsPerPage]="userSettings()?.itemsPerPage"
      (hitOpened)="closeSearch()"
      (keydown.escape)="closeSearch()" />
  </kendo-dialog>
}

<main class="main container">
  <div class="content-wrapper" [style.--itemAmount]="userSettings() ? userSettings()!.itemsPerPage : 10">
    <router-outlet></router-outlet>
  </div>
</main>
@if (isHelpOpen()) {
  <!-- The manual of the current screen, opened with the help icon, ? or F1 -->
  <rc-help-panel
    #helpPanel
    [basePath]="helpBasePath()"
    [article]="helpArticle()"
    [topics]="helpTopics"
    (closed)="closeHelp()" />
}
<div kendoDialogContainer></div>
